import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Modal } from 'synfrastructure';
import { SubmissionError, reset } from 'redux-form';
import { formatValidationErrors } from '../../common/utils/getApiReducer';
import { deleteChapter } from './actions';

import DeleteForm from '../../common/forms/DeleteForm';
import Icon from '../../common/icons/Icon';

class ChapterList extends Component {
  static propTypes = {
    chapters: PropTypes.object,
    courseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    dispatch: PropTypes.func,
  };

  state = {
    deleteChapterId: null,
    deleteChapterModalVisible: false,
    deleteChapterName: null,
  };

  onDeleteChapterSubmit = () => {
    const { courseId, dispatch } = this.props;

    return dispatch(deleteChapter(courseId, this.state.deleteChapterId)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.toggleDeleteChapterModal();
      }
    });
  };

  toggleDeleteChapterModal = (id, name) => {
    if (this.state.deleteChapterModalVisible) {
      this.props.dispatch(reset('deleteForm'));
      this.setState(state => ({
        deleteChapterId: null,
        deleteChapterModalVisible: false,
        deleteChapterName: null,
      }));
    } else {
      this.setState(state => ({
        deleteChapterId: id,
        deleteChapterModalVisible: true,
        deleteChapterName: name,
      }));
    }
  };

  render() {
    const { chapters, courseId } = this.props;
    const { deleteChapterModalVisible, deleteChapterName } = this.state;

    return (
      <div className="admin-paper">
        <Modal isVisible={deleteChapterModalVisible} onClose={this.toggleDeleteChapterModal}>
          <DeleteForm
            entityType="Chapter"
            initialValues={{ name: null }}
            onSubmit={this.onDeleteChapterSubmit}
            onCancel={this.toggleDeleteChapterModal}
            requiredConfirmationText={deleteChapterName}
          />
        </Modal>
        <ul className="admin-paper__list" key="course-chapters">
          {chapters.get('data').size ? (
            chapters.get('data').map((chapter, index) => (
              <li key={`chapter-${chapter.get('id')}`}>
                <div className="admin-paper__list__title">
                  <Icon icon="Bookmark" />
                  {`Chapter ${index + 1}: ${chapter.get('name')}`}
                </div>
                <div className="admin-paper__list__actions">
                  <Link to={`/courses/${courseId}/chapters/${chapter.get('id')}`}>
                    <Icon icon="Pencil" />
                  </Link>
                  <span onClick={this.toggleDeleteChapterModal.bind(this, chapter.get('id'), chapter.get('name'))}>
                    <Icon icon="Trash" />
                  </span>
                </div>
              </li>
            ))
          ) : (
            <div className="admin-paper__no-content">There are currently no chapters</div>
          )}
        </ul>
      </div>
    );
  }
}

export default connect(state => {
  return {
    chapters: state.courses.chapters,
  };
})(ChapterList);



// WEBPACK FOOTER //
// ./src/courses/chapters/ChapterList.js